import { Component, OnInit, ViewChild } from '@angular/core';

import {
  AuthorizationService,
  ClientSideDataTable,
  Column,
  OrganizationService,
  Store,
  StoreService,
  TitleService
} from '@ng-cloud/badger-core';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { take } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import * as _ from 'lodash';

@Component({
    templateUrl: './stores.component.html',
    styleUrls: ['./stores.component.scss'],
    standalone: false
})
export class StoresComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  private hasAccess = false;
  storeContainers: StoreContainer[] = [];
  dataTable: ClientSideDataTable<Store>;

  constructor(
    private storeService: StoreService,
    public titleService: TitleService,
    private organizationService: OrganizationService,
    private authorizationService: AuthorizationService,
    public media: MediaObserver) {
    authorizationService.accessToAny(['admin']).subscribe(hasAccess => {
      this.hasAccess = hasAccess;
      this.createStoresTable();
    });
  }

  ngOnInit() {
    this.titleService.setTitle('Stores');

    const params = {};

    this.storeService.getStores(params).subscribe(stores => {
        stores.forEach(store => {
          const container = new StoreContainer(store);
          this.organizationService.addOrganization(container).subscribe();

          this.authorizationService.accessToAny(['client_portal', 'admin']).pipe(take(1)).subscribe(hasAccess => {
            container.hasInspectAccess = hasAccess && _.includes(store.solutions, 'inspect');
          });
          this.authorizationService.accessToAny(['user', 'admin', 'realogram_editor', 'insight_auditor', 'external_insight_auditor']).pipe(take(1)).subscribe(hasAccess => {
            container.hasInsightAccess = hasAccess && _.includes(store.solutions, 'insight');
          });

          if (container.hasInspectAccess || container.hasInsightAccess) {
            this.storeContainers.push(container);
          }
        });
        this.dataTable.data = this.storeContainers;
      }
    );

    this.dataTable.sort = this.sort;
    this.dataTable.paginator = this.paginator;
    this.dataTable.mediaObserver = this.media;
    this.dataTable.filter = new FormGroup({
      filter: new FormControl()
    });
  }

  private createStoresTable() {
    const columnDefs: Column[] = [];
    columnDefs.push(new Column('name'));
    columnDefs.push(new Column('clientStoreId'));
    if (this.hasAccess === true) {
      columnDefs.push(new Column('organization.name'));
    }
    columnDefs.push(new Column('city'));
    columnDefs.push(new Column('state'));
    columnDefs.push(new Column('solutions'));
    this.dataTable = new ClientSideDataTable<Store>(columnDefs);
  }
}

class StoreContainer extends Store {
  hasInsightAccess = false;
  hasInspectAccess = false;

  constructor(store: Store) {
    super();
    this.assign(store);
  }
}
